
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { slideInVariants } from '@/lib/animations';

const WorkPerformanceRecentEntries = () => {
  // Dados de exemplo para a tabela de registros recentes
  const recentEntries = [
    { data: '18/05/2025', produtividade: 75, foco: 68, satisfacao: 70, eficiencia: 72 },
    { data: '17/05/2025', produtividade: 69, foco: 72, satisfacao: 67, eficiencia: 73 },
    { data: '16/05/2025', produtividade: 60, foco: 58, satisfacao: 55, eficiencia: 62 },
    { data: '15/05/2025', produtividade: 68, foco: 65, satisfacao: 62, eficiencia: 70 },
    { data: '14/05/2025', produtividade: 65, foco: 70, satisfacao: 60, eficiencia: 68 },
  ];

  return (
    <motion.div
      variants={slideInVariants.up}
      initial="initial"
      animate="animate"
      transition={{ delay: 0.3 }}
    >
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Registros Recentes</CardTitle>
            <CardDescription>Seus últimos 5 registros de desempenho</CardDescription>
          </div>
          <Button variant="ghost" size="icon">
            <Settings className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data</TableHead>
                <TableHead>Produtividade</TableHead>
                <TableHead>Foco</TableHead>
                <TableHead>Satisfação</TableHead>
                <TableHead>Eficiência</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recentEntries.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>{entry.data}</TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-brand-blue rounded-full" style={{width: `${entry.produtividade}%`}}></div>
                      </div>
                      {entry.produtividade}%
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-purple-500 rounded-full" style={{width: `${entry.foco}%`}}></div>
                      </div>
                      {entry.foco}%
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-green-500 rounded-full" style={{width: `${entry.satisfacao}%`}}></div>
                      </div>
                      {entry.satisfacao}%
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-yellow-500 rounded-full" style={{width: `${entry.eficiencia}%`}}></div>
                      </div>
                      {entry.eficiencia}%
                    </div>
                  </TableCell>
                  <TableCell>
                    <Button variant="ghost" size="sm">Detalhes</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default WorkPerformanceRecentEntries;
